import { moduleRegistry } from '../module-registry.js';
import { controlsNoteText } from './game-room-gate.js';

function applyControllerProfilesEntry() {
  document.getElementById('controls-dialog-controllers-entry')
    ?.classList.toggle('hidden', moduleRegistry.getFeatures().controller_profiles !== true);
}

/**
 * Footer "Controls" keyboard-reference dialog (homepage v2 spec §4.10).
 *
 * The static markup lives in index.html (#controls-dialog — a COPY of the
 * v1 card's reference, which stays for the legacy layout). The global
 * modal focus manager supplies trap + restore via aria-modal; Escape is
 * per-dialog by that module's contract. Idempotent — the caller runs on
 * every chrome render.
 */
export function initControlsDialog(app = null) {
  const btn = document.getElementById('footer-controls-link');
  const dialog = document.getElementById('controls-dialog');
  if (!btn || !dialog) return;

  applyControllerProfilesEntry();
  if (!dialog.dataset.controllerFlagsWired) {
    dialog.dataset.controllerFlagsWired = '1';
    window.addEventListener('retroplay:flags-loaded', applyControllerProfilesEntry);
  }

  if (btn.dataset.wired) return;
  btn.dataset.wired = '1';

  const close = () => dialog.classList.add('hidden');
  btn.addEventListener('click', () => {
    // H6: checked at every opening. With the app, the note names the Controls tab when the next
    // game would use the room; otherwise, or without an app, it keeps today's text.
    const note = document.getElementById('controls-dialog-note');
    if (note) note.textContent = controlsNoteText(app);
    dialog.classList.remove('hidden');
    // Deferred one macrotask: the focus manager records the opener from a
    // MutationObserver callback — focusing synchronously would make it see
    // focus already inside and never restore it on close (PR #208 lesson).
    setTimeout(() => {
      if (!dialog.classList.contains('hidden')) {
        document.getElementById('controls-dialog-close')?.focus();
      }
    }, 0);
  });
  document.getElementById('controls-dialog-close')?.addEventListener('click', close);
  dialog.addEventListener('click', (e) => { if (e.target === dialog) close(); });
  dialog.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
}
